<script lang="ts">
  import { fade } from 'svelte/transition';
  import { loadingOverlayState } from '../stores/ui';
</script>

{#if $loadingOverlayState.isVisible}
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm"
    transition:fade={{ duration: 150 }}
  >
    <div class="flex min-w-[220px] flex-col items-center gap-3 rounded-2xl px-6 py-5 shadow-xl">
      <div
        class="h-10 w-10 animate-spin rounded-full border-4 border-blue-500/20 border-t-blue-500"
        aria-hidden="true"
      ></div>
      <p class="text-sm font-medium" role="status">{$loadingOverlayState.message}</p>
      <span class="sr-only">Probíhá načítání</span>
    </div>
  </div>
{/if}
